import React, { Component } from "react";
import styled from "styled-components";

const Container = styled.div.attrs(({ hasScroll }) => ({
    style: {
        width: hasScroll ? "calc(100% + 28px)" : "calc(100% + 4px)"
    }
}))`
    overflow-y: auto;
    overflow-x: hidden;
    overflow-y: auto;
    overflow-x: clip;
    padding-bottom: 17px;
    padding-right: 4px;
`;

export class ScrollContainer extends Component {
    constructor() {
        super();

        this.containerRef = React.createRef();
    }

    componentDidMount() {
        this.forceUpdate();
    }

    render() {
        const { children } = this.props;

        let hasScroll = false;
        if (this.containerRef.current) {
            hasScroll = this.containerRef.current.scrollHeight > this.containerRef.current.clientHeight;
        }

        return <Container ref={this.containerRef} hasScroll={hasScroll}>{children}</Container>;
    }
}
